import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength } from '@src/validation';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import Select from 'react-select';
import axiosInstance from '@src/axios-instance';

const fieldValidator = {
  name: [required, value => maxLength(value, 255)],
  association_type_id: [required],
  management_company_id: [],
  developer_id: [],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)],
  notes: [value => maxLength(value, 255)]
};
class ManagementCompanyModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : '',
        visited: false,
        error: false
      };
    });
    if (fields.association_type_id.value === '') {
      const firstTypeId = Object.keys(props.associationTypes)[0];
      fields.association_type_id.value = {
        value: firstTypeId,
        label: props.associationTypes[firstTypeId]
      };
    } else {
      fields.association_type_id.value = {
        value: fields.association_type_id.value,
        label: props.associationTypes[fields.association_type_id.value]
      };
    }

    this.state = { ...fields, managementCompanies: [], developers: [] };
  }

  componentDidMount = () => {
    axiosInstance()
      .get('/management-companies/get-list.json')
      .then(response => {
        if (this.state.management_company_id.value !== '') {
          const mcIndex = response.data.find(
            x => x.value === this.state.management_company_id.value
          );
          this.setState({
            managementCompanies: response.data,
            management_company_id: {
              value: mcIndex,
              visited: false,
              error: false
            }
          });
        } else {
          this.setState({
            managementCompanies: response.data
          });
        }
      });
    axiosInstance()
      .get('/developers/get-list.json')
      .then(response => {
        if (this.state.developer_id.value !== '') {
          const mcIndex = response.data.find(
            x => x.value === this.state.developer_id.value
          );
          this.setState({
            developers: response.data,
            developer_id: {
              value: mcIndex,
              visited: false,
              error: false
            }
          });
        } else {
          this.setState({
            developers: response.data
          });
        }
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      if (
        this.props.entity !== undefined &&
        this.props.entity.id !== undefined
      ) {
        this.props.onEdit(this.props.entity.id, postData, () =>
          this.props.toggle()
        );
      } else {
        this.props.onCreate(postData, this.props.history);
      }
    }
    return false;
  };

  render = () => {
    const optionTypes = [];
    Object.keys(this.props.associationTypes).map(index => {
      optionTypes.push({
        value: index,
        label: this.props.associationTypes[index]
      });
      return false;
    });

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined
              ? 'Edit Association'
              : 'Create New Association'}
          </ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  <LabelInput
                    name={'Name'}
                    type={'text'}
                    required={true}
                    {...this.state.name}
                    onChange={event => this.updateForm(event, 'name')}
                  />
                </Col>
                <Col>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>Type</label>
                    <Select
                      value={this.state.association_type_id.value}
                      options={optionTypes}
                      onChange={event =>
                        this.updateForm(event, 'association_type_id')
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Address Line 1'}
                    type={'text'}
                    {...this.state.address_line_1}
                    onChange={event => this.updateForm(event, 'address_line_1')}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'Address Line 2'}
                    type={'text'}
                    {...this.state.address_line_2}
                    onChange={event => this.updateForm(event, 'address_line_2')}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'City'}
                    type={'text'}
                    {...this.state.city}
                    onChange={event => this.updateForm(event, 'city')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'State'}
                    type={'text'}
                    {...this.state.state}
                    onChange={event => this.updateForm(event, 'state')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Zip Code'}
                    type={'text'}
                    {...this.state.zip_code}
                    onChange={event => this.updateForm(event, 'zip_code')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>
                      Management Company
                    </label>
                    <Select
                      value={this.state.management_company_id.value}
                      options={this.state.managementCompanies}
                      onChange={event =>
                        this.updateForm(event, 'management_company_id')
                      }
                      isClearable
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>Developer</label>
                    <Select
                      value={this.state.developer_id.value}
                      options={this.state.developers}
                      onChange={event => this.updateForm(event, 'developer_id')}
                      isClearable
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Notes'}
                    type={'textarea'}
                    {...this.state.notes}
                    onChange={event => this.updateForm(event, 'notes')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.managementCompany.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCreate: (postData, history) =>
      dispatch(actions.createAssociation(postData, history)),
    onEdit: (entityId, postData, callback) =>
      dispatch(actions.editAssociation(entityId, postData, callback))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementCompanyModal);
